'use client';
import { useRef, useEffect } from "react";
function useScrollableRef(trackableState) {
  const itemRef = useRef(null);
  useEffect(() => {
    if (!(itemRef == null ? void 0 : itemRef.current)) return;
    itemRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  }, [trackableState]);
  return itemRef;
}
export {
  useScrollableRef
};
